import { useEffect, useState } from "react";
export function useIsOffline() {
    var _a = useState(function () {
        return typeof navigator !== "undefined" ? !navigator.onLine : false;
    }), isOffline = _a[0], setIsOffline = _a[1];
    useEffect(function () {
        var handleOnline = function () { return setIsOffline(false); };
        var handleOffline = function () { return setIsOffline(true); };
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return function () {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);
    return isOffline;
}
